import { useEffect } from "react";
import { Link } from 'react-router-dom';
function Solution() {
    useEffect(() => {
    window.scrollTo(0, 0);
    }, []);
    return (
        <div className="page">
          <div className="sub solution">
            <div className="visual">
              <div className="dimBg2"></div>
              <div className="container">
                <div className="text">
                  언제나 함께 하는 사람들
                  <br />
                  KNO1996입니다.
                </div>
              </div>
            </div>
            <div className="container">
              <div className="subPageTitle">
                  솔루션
              </div>
            </div>
            <div className="solutionWrap">
              <div className="container">
                <div className="item">
                  <div className="title">
                    보안 솔루션
                  </div>
                  <div className="exp">
                    
보안 솔루션에는 엔드포인트 보호와 사이버 위협 방어를 제공하는 Bitdefender, 클라우드 기반 취약점 관리와 위협 탐지 서비스를 제공하는 Qualys, 그리고 OT 및 IoT 환경에서의 네트워크 가시성과 실시간 위협 탐지를 전문으로 하는 노조미네트웍스와 같은 다양한 제품이 포함되어 있으며, 각각 고유한 기술과 접근 방식을 통해 기업의 보안 요구 사항을 충족시킵니다.
                  </div>
                </div>
                <div className="item">
                  <div className="title">
                    실시간원격복제
                  </div>
                  <div className="exp">
                  SILCROAD는 실시간 원격 복제 기능을 통해 데이터의 연속적인 복제를 지원하며, 이는 기업 환경에서 데이터 무결성과 고가용성을 유지하기 위한 핵심 솔루션으로 작동하여 장애 발생 시 데이터 손실을 최소화하고, 비즈니스 연속성을 보장하기 위한 강력한 데이터 보호와 복구 역량을 제공합니다.
                  </div>
                </div>
                <div className="item">
                  <div className="title">
                    데이터보호
                  </div>
                  <div className="exp">
                  on-premise 백업 및 아카이빙 방식을 활용할 때 데이터의 저장과 복구 과정을 기업 내부에서 직접 관리할 수 있도록 지원하며, 민감한 데이터의 물리적 보안을 강화하고, 네트워크 의존성을 줄여 사이버 위협 및 데이터 유출 가능성을 최소화하며, 또한 데이터 주권 요구 사항과 규제 준수 측면에서 유리한 환경을 제공하여 장기 보관이 필요한 데이터의 효율적인 아카이빙과 함께 신속한 데이터 복구를 통해 비즈니스 연속성과 데이터 무결성을 보장하는 데 중요한 역할을 합니다.
                  </div>
                </div>
                <p className="moreExp">
                검증된 기술력과 다양한 솔루션으로 최적화된 서비스를 제공합니다. 지금 저희와 함께해 강화된 보안과 신뢰를 경험하세요.
                </p>
              </div>
            </div>
          </div>
        </div>
      );
}
export default Solution;